///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class InstructionScreen extends BaseScreen {

        bg:Phaser.GameObjects.Image;
        nextBtn:Phaser.GameObjects.Image;
        ronald_mc:Phaser.GameObjects.Sprite;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.bg = new Phaser.GameObjects.Image(this.scene, -1, -1, 'ui-atlas', 'bg_story'+'0000');
            this.bg.setOrigin(0, 0);
            this.add(this.bg);
            this.bg.setInteractive({cursor: 'pointer'});
            this.bg.once('pointerup', this.skip);

            this.nextBtn = new Phaser.GameObjects.Image(this.scene, 330, 290, 'ui-atlas', 'btn_next_story'+'0000');
            this.add(this.nextBtn);
            this.nextBtn.setInteractive({cursor: 'pointer'});
            this.nextBtn.once('pointerup', this.skip);

            let label_next:Phaser.GameObjects.Text = this.scene.add.text(this.nextBtn.x, this.nextBtn.y-5, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 22,
                "color": "#FFFFFF",
                "align": 'left'
            });
            label_next.setOrigin(0.5, 0.5);
            this.add(label_next);
            nscs.gameplay.Gameplay.setText(label_next, 'NextBtn');

            let label_Instruct1:Phaser.GameObjects.Text = this.scene.add.text(30, 25, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 12,
                "color": "#FFFFFF",
                "align": 'left'
            });
            label_Instruct1.setWordWrapWidth(290);
            this.add(label_Instruct1);
            nscs.gameplay.Gameplay.setText(label_Instruct1, 'Instruct1');

            let label_Instruct2:Phaser.GameObjects.Text = this.scene.add.text(160, 180, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 12,
                "color": "#FFFFFF",
                "align": 'left'
            });
            label_Instruct2.setWordWrapWidth(290);
            this.add(label_Instruct2);
            nscs.gameplay.Gameplay.setText(label_Instruct2, 'Instruct2');

            let lost_burger = new Phaser.GameObjects.Image(this.scene, 400,120, 'ui-atlas', 'lost_burger'+'0000');
            this.add(lost_burger);

            this.ronald_mc = this.scene.add.sprite(lost_burger.x-10, lost_burger.y-35, 'ui-atlas', 'ronald_mc0000');
            let ronald_mc_anims:object = {
                'appear': {start: 0, end: 37},
                'disappear': {start: 38, end: 70},
                'disappeared': {start: 71, end: 83},
                'hit': {start: 84, end: 255},
                'idle': {start: 256, end: 798},
                'laugh': {start: 799, end: 884},
                'midLaugh': {start: 826, end: 884}
            };
            for (let an in ronald_mc_anims) {
                if (!this.scene.anims.exists(an)) {
                    this.scene.anims.create({
                        key: an,
                        frames: this.scene.anims.generateFrameNames('ui-atlas', {
                            start: ronald_mc_anims[an]['start'], end: ronald_mc_anims[an]['end'], zeroPad: 4,
                            prefix: 'ronald_mc', suffix: ''
                        }),
                        frameRate: 60
                    });
                }
            }
            this.ronald_mc.play('idle');
            this.add(this.ronald_mc);

            let eyes_mc = new Phaser.GameObjects.Image(this.scene, this.ronald_mc.x-13,this.ronald_mc.y-30, 'ui-atlas', 'eyes_mc'+'0000');
            this.add(eyes_mc);
            let eyes_mc_anim:()=>void = ()=>{
                if (eyes_mc.frame.name == 'eyes_mc'+'0000') {
                    nscs.util.Functions.delayedCall(250, eyes_mc_anim);
                    eyes_mc.setFrame('eyes_mc'+'0001');
                } else {
                    nscs.util.Functions.delayedCall(Math.ceil(Math.random()*3)*1000, eyes_mc_anim);
                    eyes_mc.setFrame('eyes_mc'+'0000');
                }
            };
            eyes_mc_anim();

            let fn:()=>void = ()=>{
                this.dc = nscs.util.Functions.delayedCall(Math.ceil(Math.random()*3)*1000, fn);
                if (Math.random()>0.85) {
                    this.ronald_mc.play('laugh');
                    nscs.sound.SoundManager.getInstance().playSound(Phaser.Utils.Array.GetRandom(['laugh1SND','laugh2SND','laugh3SND']))
                    eyes_mc.visible = false;
                } else {
                    this.ronald_mc.play('idle');
                    eyes_mc.visible = true;
                }
            };
            fn();
        }

        private alreadySkipped:boolean = false;
        public skip:()=>void = ()=>{
            if (this.alreadySkipped) return;
            this.alreadySkipped = true;

            nscs.scene.MainScene.instance.switchScreen(new nscs.screen.KidFriendlyScreen(this.scene));
            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
        };

        private dc;
        public destroy(fromScene?: boolean): void {
            nscs.util.Functions.destroyDelayedCall(this.dc);
            super.destroy(fromScene);
        }

        public updateScreen(): void {
            super.updateScreen();

            if (!this.alreadySkipped) {
                if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                    nscs.scene.MainScene.instance.switchScreen(new MainMenuScreen(this.scene));
                }
            }
        }
    }
}